import { createContext } from "react"
export const TranslateContext = createContext<boolean>(false)
export const SetTranslateContext = createContext<React.Dispatch<React.SetStateAction<boolean>>>((e) => !e)